// eslint-disable-next-line import/prefer-default-export
export const CLIENT_ROLE = 'client';
export const AGENT_ROLE = 'agent';
